var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "js",
    className: "cls-1",
    d: "M0,32v70H70V32ZM38.094,86.594c0,6.813-4,9.922-9.828,9.922-5.266,0-8.313-2.719-9.875-6.016l5.359-3.234c1.031,1.828,1.969,3.375,4.234,3.375,2.156,0,3.531-.844,3.531-4.141V64.141h6.578V86.594Zm15.563,9.922c-6.109,0-10.062-2.906-11.984-6.719L47.031,86.7c1.406,2.3,3.25,4,6.484,4,2.719,0,4.469-1.359,4.469-3.25,0-2.25-1.781-3.047-4.8-4.375l-1.641-.7c-4.75-2.016-7.891-4.563-7.891-9.922,0-4.937,3.766-8.688,9.625-8.688,4.187,0,7.188,1.453,9.344,5.266L57.5,72.313C56.375,70.3,55.156,69.5,53.266,69.5a2.855,2.855,0,0,0-3.141,2.813c0,1.969,1.219,2.766,4.047,4l1.641.7c5.594,2.391,8.734,4.844,8.734,10.344,0,5.906-4.656,9.156-10.891,9.156Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.2d68d38720fa7776fb6f8a43c773b821.svg";
export { ForwardRef as ReactComponent };